import React, { Component } from "react";

import { withRouter } from "react-router-dom";
import { revisionService } from "libs/api/revisionService";
import { dateHelper, networkErrorHelper } from "libs";
import { Card, CardBody } from "design-react-kit";
import ReactHtmlParser from "react-html-parser";
import { BoxDanger, MnemoLoading } from "components/misc";
import i18n from "app/i18n";

class MyQuizReview extends Component {
  state = {
    review: {},
    loadingError: "",
    isLoading: true,
  };

  componentDidMount() {
    const { idQuizReview } = this.props.match.params;

    //--- prevent loadRemote when not required ---
    if (parseInt(idQuizReview) <= 0) {
      this.setState({
        isLoading: false,
        loadingError: "Parametro del Quiz non valido",
      });
    } else {
      this.loadRemote(idQuizReview);
    }
  }

  loadRemote(idQuizReview) {
    revisionService
      .getQuizReview(parseInt(idQuizReview))
      .then(({ data }) => {
        console.log(data.payload);

        const review = data.payload.quizReview;
        this.setState({
          review,
          isLoading: false,
        });

        if (review.toFeedback) {
          this.updateToFeedback(review);
        }
      })
      .catch((error) => {
        networkErrorHelper.notify(error);
        const errorMessage = networkErrorHelper.getErrorMessage(error);
        this.setState({ isLoading: false, loadingError: errorMessage });
        console.log(error);
      });
  } //loadremote

  updateToFeedback = (review) => {
    const payload = {
      id: review.id,
      toFeedback: false,
    };

    revisionService
      .updateQuizReviewFeedback(payload)
      .then((data) => {})
      .catch((errors) => {
        console.log(errors);
      });
  };

  render() {
    const { review, loadingError, isLoading } = this.state;

    if (isLoading) return <MnemoLoading />;

    return (
      <>
        {loadingError ? (
          <BoxDanger>
            Si è verificato il seguente errore: {loadingError}
          </BoxDanger>
        ) : (
          <>
            <Card
              tag="div"
              className="card-bg card-big rounded shadow border-bottom-card"
            >
              <div className="flag-icon" />
              <CardBody tag="div">
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="courseCode" className="active">
                        Codice Corso
                      </label>
                      {review.courseCode}
                    </div>
                  </div>
                </div>

                {/** elemento domanda */}

                {(review.items || []).sort((a, b) => a.idQuizAttemptQuestion - b.idQuizAttemptQuestion).map((item, index) => {
                  return (
                    <div className="row" key={index}>
                      <div className="col-md-12">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="question" className="active">
                              Domanda
                            </label>
                            {ReactHtmlParser(item.question)}
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="answer" className="active">
                              Risposta
                            </label>
                            {item.answer.endsWith(".wav") ? (
                              <audio controls src={item.answerUrl}></audio>
                            ) : (
                              ReactHtmlParser(item.answer)
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}

                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="revisionResult" className="active">
                        Risultato revisione
                      </label>
                      {i18n.t(review.revisionResult.replace(/ /g, "") + "_en")}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label htmlFor="reviionDate" className="active">
                        Data revisione
                      </label>
                      {dateHelper.toITDate(review.revisionDate)}
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="revisionNote" className="active">
                        Note revisione
                      </label>
                      {review.revisionNote}
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </>
        )}
      </>
    );
  }
}

export default withRouter(MyQuizReview);
